import styled from 'styled-components';

import Colors from '~/styles/colors';

export const Card = styled.div`
  background: ${Colors.white};
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  max-width: 480px;
`;

export const ValueBadge = styled.div`
  background: ${Colors.orange};
  color: ${Colors.white};
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 24px;
  font-weight: bold;
  display: inline-block;
  margin-bottom: 16px;
`;

export const SectionLabel = styled.div`
  font-size: 12px;
  color: ${Colors.grey};
  margin-bottom: 4px;
`;

export const InfoField = styled.div`
  background: ${Colors.primary};
  color: ${Colors.white};
  padding: 10px 12px;
  border-radius: 6px;
  margin-bottom: 8px;
  font-size: 14px;
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
  flex-wrap: wrap;
`;
